/* Little Jukey – Waitlist landing section */
if (!customElements.get('lj-waitlist')) {
  class LjWaitlist extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 1024px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onMq = this.layout.bind(this);
      this.layout();
      this.mq.addEventListener('change', this.onMq);
      this.initCarousel();
      this.initForm();
      this.initSticky();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.mq) this.mq.removeEventListener('change', this.onMq);
      if (this.io) this.io.disconnect();
    }

    /* Desktop: carousel moves to the right column, form moves above the kit line */
    layout() {
      const car = this.querySelector('[data-ljw-car]');
      const mob = this.querySelector('[data-ljw-mob-car]');
      const desk = this.querySelector('[data-ljw-desk-car]');
      const join = this.querySelector('[data-ljw-join]');
      const left = join && join.parentElement;
      const kit = this.querySelector('[data-ljw-kit]') || this.querySelector('.ljw-badges');
      const foot = this.querySelector('[data-ljw-foot]');
      if (this.mq.matches) {
        if (car && desk) desk.appendChild(car);
        if (join && kit && left) left.insertBefore(join, kit);
      } else {
        if (car && mob) mob.appendChild(car);
        if (join && left) left.insertBefore(join, foot || null);
      }
      if (this.track) this.track.scrollLeft = this.track.clientWidth * this.index();
    }

    /* Carousel */
    initCarousel() {
      this.track = this.querySelector('[data-ljw-track]');
      this.dots = Array.from(this.querySelectorAll('[data-ljw-dot]'));
      if (!this.track || this.dots.length < 2) return;
      this.paused = false;
      const car = this.querySelector('[data-ljw-car]');
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          this.go(i);
          this.restart();
        })
      );
      car.addEventListener('mouseenter', () => (this.paused = true));
      car.addEventListener('mouseleave', () => (this.paused = false));
      this.track.addEventListener('focusin', () => (this.paused = true));
      this.track.addEventListener('focusout', () => (this.paused = false));
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') this.paused = true;
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index() - 1); }
      });
      window.addEventListener('resize', () => {
        this.track.scrollLeft = this.track.clientWidth * this.index();
      });
      this.restart();
    }

    index() {
      return this.track ? Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)) : 0;
    }

    go(i) {
      const n = this.dots.length;
      this.track.scrollTo({ left: this.track.clientWidth * ((i + n) % n), behavior: this.reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const i = this.index();
      this.dots.forEach((d, j) => d.setAttribute('aria-current', j === i ? 'true' : 'false'));
    }

    restart() {
      clearInterval(this.timer);
      const speed = parseInt(this.dataset.autoplay, 10) || 3000;
      if (this.reduce || (window.Shopify && window.Shopify.designMode)) return;
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden) this.go(this.index() + 1);
      }, speed);
    }

    /* Form */
    initForm() {
      this.join = this.querySelector('[data-ljw-join]');
      const posted = this.querySelector('[data-ljw-posted]');
      if (posted) {
        this.forced = true;
        posted.scrollIntoView({ block: 'center' });
        posted.focus({ preventScroll: true });
        return;
      }
      this.form = this.querySelector('form.ljw-form');
      if (!this.form) return;
      this.fields = this.querySelector('[data-ljw-fields]');
      this.thanks = this.querySelector('[data-ljw-thanks]');
      this.date = this.querySelector('[data-ljw-date]');

      if (this.date) {
        const min = new Date();
        min.setFullYear(min.getFullYear() - 3);
        const max = new Date();
        max.setMonth(max.getMonth() + 10);
        this.date.min = this.iso(min);
        this.date.max = this.iso(max);
        const box = this.querySelector('[data-ljw-date-box]');
        box.addEventListener('click', () => {
          try { if (this.date.showPicker) this.date.showPicker(); } catch (e) { /* not supported */ }
          this.date.focus();
        });
      }

      this.querySelectorAll('.ljw-field input').forEach((input) =>
        input.addEventListener('input', () => this.setErr(input.closest('.ljw-field'), false))
      );
      this.form.addEventListener('submit', (e) => this.submit(e));
    }

    iso(d) {
      return d.toISOString().slice(0, 10);
    }

    setErr(field, bad) {
      if (!field) return false;
      field.setAttribute('aria-invalid', bad ? 'true' : 'false');
      field.querySelector('input').setAttribute('aria-invalid', bad ? 'true' : 'false');
      return bad;
    }

    validDate(v) {
      if (!v || !this.date) return true;
      const d = new Date(v + 'T00:00:00');
      return !isNaN(d) && (!this.date.min || v >= this.date.min) && (!this.date.max || v <= this.date.max);
    }

    submit(e) {
      const name = this.form.querySelector('[name="contact[first_name]"]');
      const email = this.form.querySelector('[name="contact[email]"]');
      const dv = this.date ? this.date.value : '';
      const b1 = this.setErr(name.closest('.ljw-field'), !name.value.trim());
      const b2 = this.setErr(email.closest('.ljw-field'), !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim()));
      const b3 = this.date ? this.setErr(this.date.closest('.ljw-field'), !this.validDate(dv)) : false;
      if (b1 || b2 || b3) {
        e.preventDefault();
        const bad = this.form.querySelector('.ljw-field[aria-invalid="true"] input');
        if (bad) bad.focus();
        return;
      }

      const key = this.dataset.klaviyoKey;
      const list = this.dataset.klaviyoList;
      const btn = this.form.querySelector('[data-ljw-submit]');

      /* Shopify customer form: add the date as a tag, then let the form post normally */
      if (!key || !list) {
        const tags = this.form.querySelector('[data-ljw-tags]');
        if (tags) {
          const parts = [tags.dataset.base].filter(Boolean);
          if (dv) parts.push('baby-date-' + dv);
          tags.value = parts.join(', ');
        }
        btn.disabled = true;
        return;
      }

      /* Klaviyo list */
      e.preventDefault();
      btn.disabled = true;
      const props = { source: 'waitlist' };
      if (dv) props.baby_date = dv;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Waitlist',
              profile: { data: { type: 'profile', attributes: { email: email.value.trim(), first_name: name.value.trim(), properties: props } } },
            },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      })
        .then((r) => {
          if (!r.ok) throw new Error('Klaviyo');
          this.done();
        })
        .catch(() => {
          btn.disabled = false;
          this.setErr(email.closest('.ljw-field'), true);
        });
    }

    done() {
      if (this.fields) this.fields.hidden = true;
      if (this.thanks) {
        this.thanks.hidden = false;
        this.thanks.focus();
      }
      this.forced = true;
      this.hideSticky(true);
      const url = this.dataset.redirect;
      if (url) setTimeout(() => (window.location.href = url), 1800);
    }

    /* Sticky button (mobile) */
    initSticky() {
      this.sticky = this.querySelector('[data-ljw-sticky]');
      if (!this.sticky || !this.join) return;
      this.querySelector('[data-ljw-sticky-btn]').addEventListener('click', () => {
        this.join.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'center' });
        const first = this.join.querySelector('input:not([type="hidden"])');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 450);
      });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => this.hideSticky(entries[0].isIntersecting), { threshold: 0.25 });
        this.io.observe(this.join);
      }
      if (this.forced) this.hideSticky(true);
    }

    hideSticky(hide) {
      if (!this.sticky) return;
      this.sticky.classList.toggle('is-hidden', hide || this.forced);
    }
  }
  customElements.define('lj-waitlist', LjWaitlist);
}
